import { Component, OnInit, ViewChild, Input, ViewChildren, QueryList, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { FormGroup, Validators, FormControl, FormBuilder, NgModel } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarClienteTiposComponent } from 'src/app/views/shared/modal-seleccionar-cliente-tipos/modal-seleccionar-cliente-tipos.component';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component'
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import gql from 'graphql-tag';
import { MDBDatePickerComponent, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { debounceTime, filter } from 'rxjs/operators';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ModalShowClientesComponent } from '../modal-show-clientes/modal-show-clientes.component';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ProductoService } from 'src/app/services/producto.service';

type MODE = 'ADD' | 'EDIT' | 'VIEW'

@Component({
  selector: 'app-modal-addedit-promocion',
  templateUrl: './modal-addedit-promocion.component.html',
  styleUrls: ['./modal-addedit-promocion.component.scss'],
  providers: [SecurityService],
})
export class ModalAddeditPromocionComponent implements OnInit {

  // Inputs
  @Input() optionsTipoDescuento: any = []
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = []
  @Input() permiteUnidadNegocio: any = []

  // Outputs
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('agregarPromocion', { static: true }) modalAgregarPromocion: ModalDirective
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarClienteTiposComponent, { static: true }) modalSeleccionarClientesTipos: ModalSeleccionarClienteTiposComponent
  // @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent
  // @ViewChildren("UserDetailComponent") userDetailReferences: QueryList<NgModel>;
  @ViewChildren(ModalSeleccionarProductoComponent) modalesSeleccionProductos: QueryList<ModalSeleccionarProductoComponent>
  @ViewChild('datePickerInicio', { static: true }) datePickerInicio: MDBDatePickerComponent
  @ViewChild('datePickerFinal', { static: true }) datePickerFinal: MDBDatePickerComponent
  @ViewChild(ModalShowClientesComponent, { static: true }) modalShowClientes: ModalShowClientesComponent

  // Form
  formHeader: FormGroup
  formCondicion: FormGroup
  formPromocion: FormGroup

  // Constants
  readonly TIPO_CLIENTE: String = `_CLIENTE_`
  readonly TIPO_TIPO_CLIENTE: String = `_TIPO_CLIENTE_`

  readonly MODAL_SEL_PROD_PROMOCION = 'MODAL_SEL_PROD_PROMOCION'
  readonly MODAL_SEL_PROD_CONDICION = 'MODAL_SEL_PROD_CONDICION'

  // Data &  Tmp
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  listaPromocionesCondicion: any = []
  listaPromocionesPromocion: any = []
  private loading: boolean = false
  private loaded: boolean = false
  defaultUnidadNegocio: number = null

  codigoPromocion: number = -1
  // clienteSeleccionado: any = null
  clientesSeleccionados: Array<any> = null
  clientesSeleccionadosFormatted: String = null
  tiposClientesSeleccionados: any = null
  tiposClientesSeleccionadosFormatted: String = null
  productoSeleccionadoCondicion: any = null
  productoSeleccionadoPromocion: any = null
  optionsFormatoCondicion: any = []
  optionsFormatoPromocion: any = []
  mode: MODE

  // Utils
  private log: any

  // getters
  get modalCondicion() {
    return this.modalesSeleccionProductos.filter(mod => mod.origen === this.MODAL_SEL_PROD_CONDICION)[0]
  }

  get modalPromocion() {
    return this.modalesSeleccionProductos.filter(mod => mod.origen === this.MODAL_SEL_PROD_PROMOCION)[0]
  }

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private formatoProductoService: FormatoProductosService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private productoService: ProductoService
  ) {
    this.log = this.clog.log('MODAL-PROMOCIONES')
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa()
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo()
    this.createForms()
    this.formChangesSubscriptions()
  }

  trackByPromoCodigo(index: number, item: any) {
    return item && item.codigo != null ? item.codigo : index;
  }

  /********* SHOW/HIDE *********/
  show(mode: MODE) {
    this.mode = mode
    if (mode === 'ADD') {
      this.codigoPromocion = -1

      // Set unidad_negocio_codigo validator
      this.formHeader.get("unidad_negocio_codigo").enable()
      this.formHeader.get('unidad_negocio_codigo').clearValidators()
      if (this.permiteUnidadNegocio) {
        this.formHeader.get('unidad_negocio_codigo').setValidators([Validators.required])
      }
      this.formHeader.get('unidad_negocio_codigo').updateValueAndValidity()

      this.reset()
    }
    this.modalAgregarPromocion.show();
  }

  hide() {
    this.modalAgregarPromocion.hide();
  }

  reset() {
    this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside()
    this.datePickerInicio.clearDate()
    this.datePickerFinal.clearDate()

    this.resetFormHeader()

    this.resetFormCondicion()
    this.resetListaProductosCondicion()

    this.resetFormPromocion()
    this.resetListaProductosPromocion()
  }

  private resetFormHeader() {
    this.formHeader.reset()
    this.formHeader.markAsPristine()
    this.formHeader.markAsUntouched()

    this.formHeader.get("buscarPor").setValue(this.TIPO_CLIENTE)
    this.formHeader.get("clienteOrTipos").setValue(null)
    this.formHeader.get("activo").setValue(true)
    this.formHeader.get("fechaInicio").setValue('')
    this.formHeader.get("fechaFin").setValue('')
    this.formHeader.get("unidad_negocio_codigo").setValue(null)

    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.clientesSeleccionadosFormatted = null
    this.tiposClientesSeleccionados = null
    this.tiposClientesSeleccionadosFormatted = null
  }

  private resetFormCondicion() {
    this.formCondicion.reset()
    this.formCondicion.markAsPristine()
    this.formCondicion.markAsUntouched()

    this.formCondicion.get("codigo").setValue(null)
    this.formCondicion.get("formato").setValue(null)
    this.formCondicion.get("cantidad").setValue(null)

    this.productoSeleccionadoCondicion = null
    this.optionsFormatoCondicion = []
  }

  private resetListaProductosCondicion() {
    this.listaPromocionesCondicion = []
  }

  private resetFormPromocion() {
    this.formPromocion.reset()
    this.formPromocion.markAsPristine()
    this.formPromocion.markAsUntouched()

    this.formPromocion.get("codigo").setValue(null)
    this.formPromocion.get("formato").setValue(null)
    this.formPromocion.get("cantidad").setValue(null)
    this.formPromocion.get("tipoDescuento").setValue('2')
    this.formPromocion.get("montoOrPorcentaje").setValue(null)

    this.productoSeleccionadoPromocion = null
    this.optionsFormatoPromocion = []
  }

  private resetListaProductosPromocion() {
    this.listaPromocionesPromocion = []
  }
  /********* SHOW/HIDE *********/

  /********* FORMS *********/
  createForms() {
    this.formHeader = this.fb.group({
      buscarPor: [this.TIPO_CLIENTE, [Validators.required]],
      clienteOrTipos: [null, [Validators.required]],
      activo: [true],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      unidad_negocio_codigo: [null, []]
    });

    this.formCondicion = this.fb.group({
      codigo: [null, [Validators.required, Validators.min(1)]],
      formato: [null, [Validators.required]],
      cantidad: [null, [Validators.required, Validators.min(1)]],
    });

    this.formPromocion = this.fb.group({
      codigo: [null, [Validators.required, Validators.min(1)]],
      formato: [null, [Validators.required]],
      cantidad: [null, [Validators.required, Validators.min(1)]],
      tipoDescuento: ['2', [Validators.required]],
      montoOrPorcentaje: [null, [Validators.required, Validators.min(1)]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("buscarPor").valueChanges.subscribe(buscarPor => {
      this.limpiarBuscarPorCliente()
      this.limpiarBuscarPorTiposClientes()
      this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside()
    })

    this.formCondicion.get("codigo").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigo: string) => {
        this.log('formCondicion codigo valueChanges', codigo)
        this.modalCondicion.searchBySKU(codigo)
      })

    // this.formPromocion.get("codigo").valueChanges
    //   .pipe(filter(Boolean), debounceTime(1000))
    //   .subscribe((codigo: string) => {
    //     this.log('formPromocion codigo valueChanges', codigo)
    //     this.modalPromocion.searchBySKU(codigo)
    //   })

      this.formPromocion.get("codigo").valueChanges
      .pipe(filter(Boolean))
      .subscribe((codProduct: string) => {
        this.modalPromocion.searchByCodeProduct(codProduct)
      })

    this.formHeader.get("unidad_negocio_codigo").valueChanges
      .subscribe((unidad_negocio_codigo: number) => {
        this.defaultUnidadNegocio = unidad_negocio_codigo
      })
  }
  /********* FORMS *********/

  /********* MODALS *********/
  limpiarBuscarPorCliente() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.clientesSeleccionadosFormatted = null
  }

  limpiarBuscarPorTiposClientes() {
    this.tiposClientesSeleccionados = null
    this.tiposClientesSeleccionadosFormatted = null
  }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.tiposClientesSeleccionados = null
  }

  abrirModalSeleccion() {
    if (this.formHeader.get('buscarPor').value === this.TIPO_CLIENTE)
      this.abrirModalSeleccionarCliente()
    else if (this.formHeader.get('buscarPor').value === this.TIPO_TIPO_CLIENTE)
      this.abrirModalSeleccionarClientesTipos()
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected({
      paginateLocally: true,
      allowUncheckSelected: this.mode === 'EDIT' || this.mode === 'ADD'
    })
  }

  abrirModalSeleccionarTiposClienteSeleccionados() {
    this.modalSeleccionarClientesTipos.showSelected()
  }

  abrirModalSeleccionarClientesTipos() {
    this.modalSeleccionarClientesTipos.show(!this.tiposClientesSeleccionados)
  }

  // abrirModalSeleccionarProducto() {
  //   this.modalSeleccionarProducto.show()
  // }

  abrirModalSeleccionarProductoCondicion() {
    this.modalCondicion.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      defaultUnidadNegocio: this.defaultUnidadNegocio
    })
  }

  abrirModalSeleccionarProductoPromocion() {
    this.modalPromocion.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      defaultUnidadNegocio: this.defaultUnidadNegocio
    })
  }

  // remote query for modal selección Producto
  getProductsByUnidadNegocio({ inputParams, callback }) {
    // this.log('inputParams', JSON.stringify(inputParams))
    // {
    //   "empresa_rut": 76150970,
    //   "sku": "",
    //   "descripcion": "",
    //   "tipobusqueda_estado": 1,
    //   "tipobusquedad_afecto_exento": 1,
    //   "familia": [],
    //   "rubro": [],
    //   "paginaActual": 1,
    //   "cantidadRegistrosPorPagina": 10
    // }
    this.log('permiteUnidadNegocio', this.permiteUnidadNegocio)
    if (this.permiteUnidadNegocio) {
      const innerInputParams = {
        entidad: {
          empresa_rut: inputParams.empresa_rut,
          sku: inputParams.sku,
          descripcion: inputParams.descripcion,
          tipobusqueda_estado: inputParams.tipobusqueda_estado,
          tipobusquedad_afecto_exento: inputParams.tipobusquedad_afecto_exento,
          listaFamilia: inputParams.familia,
          listaRubro: inputParams.rubro,
          unidad_negocio_codigo: inputParams.unidad_negocio_codigo ? inputParams.unidad_negocio_codigo : this.defaultUnidadNegocio
        },
        paginaActual: inputParams.paginaActual,
        cantidadRegistrosPorPagina: inputParams.cantidadRegistrosPorPagina
      }

      this.log('inputParams (Unidad Negocio)', JSON.stringify(inputParams))

      this.productoService.obtenerSegunFiltroProductosUnidadNegocio(innerInputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0))
          return
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))

      })
    } else {
      this.log('inputParams', JSON.stringify(inputParams))
      this.productoService.obtenerSegunFiltroProductos2(inputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0))
          return
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))

      })
    }
  }

  onProductoNoEncontradoCondicion() {
    this.productoSeleccionadoCondicion = null
    this.optionsFormatoCondicion = []
    this.formCondicion.get("formato").setValue(null)
  }

  // onClienteSeleccionado({ data, origen }) {
  //   this.limpiarDataSeleccionada()
  //   this.clienteSeleccionado = data
  //   this.formHeader.get("clienteOrTipos").setValue(this.clienteSeleccionado)
  // }

  onClienteSeleccionadoMultiple({ data, origen }) {
    this.limpiarDataSeleccionada()
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map(p => p.nombre).join(', ')
    this.formHeader.get("clienteOrTipos").setValue(this.clientesSeleccionadosFormatted)
  }

  onClienteTiposSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada()
    this.tiposClientesSeleccionados = data
    this.formHeader.get("clienteOrTipos").setValue(this.tiposClientesSeleccionados)
    this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map(p => p.descripcion).join(', ')
  }

  onProductoSeleccionadoCondicion({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionadoCondicion = _productoSeleccionado
    this.formCondicion.get('codigo').setValue(_productoSeleccionado.sku)

    // Fill combo
    this.formatoProductoService.GetFormatosByCodigo(
      this.rutEmpresa,
      this.productoSeleccionadoCondicion.codigo,
      ({ mensajes, respuesta }) => {
        this.optionsFormatoCondicion = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }))
        this.formValidatorsService.selectDefaultFormatoProducto(this.formCondicion.get('formato'), this.optionsFormatoCondicion)
      }
    )
  }

  onProductoSeleccionadoPromocion({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionadoPromocion = _productoSeleccionado
    this.formPromocion.get('codigo').setValue(_productoSeleccionado.sku)

    // Fill combo
    this.formatoProductoService.GetFormatosByCodigo(
      this.rutEmpresa,
      this.productoSeleccionadoPromocion.codigo,
      ({ mensajes, respuesta }) => {
        this.optionsFormatoPromocion = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }))
        this.formValidatorsService.selectDefaultFormatoProducto(this.formPromocion.get('formato'), this.optionsFormatoPromocion)
      }
    )
  }

  onProductoNoEncontradoPromocion() {
    this.productoSeleccionadoPromocion = null
    this.optionsFormatoPromocion = []
    this.formPromocion.get("formato").setValue(null)
  }
  /********* MODALS *********/

  /********* OPERATIONS *********/
  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  agregarItemCondicion() {
    this.validateAllFormFields(this.formCondicion);
    if (!this.formCondicion.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return
    }

    // Validar unidad de negocio
    if (!this.validateUnidadNegocioNewProduct(this.productoSeleccionadoCondicion)) {
      this.toastrService.warning('Producto debe tener la misma unidad de negocio');
      return
    }

    // nuevo item
    const newPromocion: any = {
      codigo: this.productoSeleccionadoCondicion.codigo,
      empresa_rut: this.productoSeleccionadoCondicion.empresa_rut,
      sku: this.productoSeleccionadoCondicion.sku,
      descripcion: this.productoSeleccionadoCondicion.descripcion,
      formato: this.formCondicion.get('formato').value,
      formatoGlosa: this.optionsFormatoCondicion.filter(opt => opt.value === this.formCondicion.get('formato').value)[0].label,
      cantidad: Number(this.formCondicion.get('cantidad').value),
      valor: 0,
      index: this.listaPromocionesCondicion.length + 1
    }

    // agregar a lista
    this.listaPromocionesCondicion.push(newPromocion)
    this.toastrService.success('Registro agregado')
    this.fixAndDisableUnidadNegocio(this.productoSeleccionadoCondicion)
    this.resetFormCondicion()
  }

  validateUnidadNegocioNewProduct({ unidad_negocio_codigo }): Boolean {
    if (!this.defaultUnidadNegocio)
      return true
    return this.defaultUnidadNegocio === unidad_negocio_codigo
  }

  fixAndDisableUnidadNegocio({ unidad_negocio_codigo }) {
    this.defaultUnidadNegocio = unidad_negocio_codigo //this.formHeader.get("unidad_negocio_codigo").value
    this.formHeader.get("unidad_negocio_codigo").setValue(unidad_negocio_codigo)
    this.formHeader.get("unidad_negocio_codigo").disable()
  }

  eliminarItemCondicion(index) {
    this.listaPromocionesCondicion = this.listaPromocionesCondicion.filter(item => item.index !== index)
    this.toastrService.warning('Registro eliminado')
    this.checkAndClearDefaultUnidadDeNegocio()
  }

  checkAndClearDefaultUnidadDeNegocio() {
    if (this.listaPromocionesCondicion.length === 0 && this.listaPromocionesPromocion.length === 0) {
      this.defaultUnidadNegocio = null
      this.formHeader.get("unidad_negocio_codigo").enable()
    }
  }

  agregarItemPromocion() {
    this.validateAllFormFields(this.formPromocion);
    if (!this.formPromocion.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return
    }

    // Validar unidad de negocio
    if (!this.validateUnidadNegocioNewProduct(this.productoSeleccionadoPromocion)) {
      this.toastrService.warning('Producto debe tener la misma unidad de negocio');
      return
    }

    // nuevo item
    const newPromocion: any = {
      sku: this.productoSeleccionadoPromocion.sku,
      codigo: this.productoSeleccionadoPromocion.codigo,
      empresa_rut: this.productoSeleccionadoPromocion.empresa_rut,
      descripcion: this.productoSeleccionadoPromocion.descripcion,
      // formato: this.optionsTipoDescuento.filter(opt => Number(opt.value) === Number(this.formPromocion.get('tipoDescuento').value))[0].label,
      formato: this.formPromocion.get('formato').value,
      formatoGlosa: this.optionsFormatoPromocion.filter(opt => opt.value === this.formPromocion.get('formato').value)[0].label,
      cantidad: Number(this.formPromocion.get('cantidad').value),
      tipoDescuento: this.formPromocion.get('tipoDescuento').value,
      tipoDescuentoGlosa: this.optionsTipoDescuento.filter(opt => Number(opt.value) === Number(this.formPromocion.get('tipoDescuento').value))[0].label,
      monto: this.formPromocion.get('tipoDescuento').value === '1' ? Number(this.formPromocion.get('montoOrPorcentaje').value) : 0,
      porcentaje: this.formPromocion.get('tipoDescuento').value === '2' ? Number(this.formPromocion.get('montoOrPorcentaje').value.replace(',','.')) : 0,
      index: this.listaPromocionesPromocion.length + 1
    }

    // agregar a lista
    this.listaPromocionesPromocion.push(newPromocion)
    this.toastrService.success('Registro agregado')
    this.fixAndDisableUnidadNegocio(this.productoSeleccionadoPromocion)
    this.resetFormPromocion()
  }

  eliminarItemPromocion(index) {
    this.listaPromocionesPromocion = this.listaPromocionesPromocion.filter(item => item.index !== index)
    this.toastrService.warning('Registro eliminado')
    this.checkAndClearDefaultUnidadDeNegocio()
  }

  guardar() {
    this.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return
    }

    if (this.formHeader.get("buscarPor").value === this.TIPO_CLIENTE) {
      if (!this.clientesSeleccionados || this.clientesSeleccionados.length === 0) {
        this.toastrService.warning('Favor ingrese clientes');
        return
      }
    } else {
      if (!this.tiposClientesSeleccionados || this.tiposClientesSeleccionados.length === 0) {
        this.toastrService.warning('Favor ingrese tipos de clientes');
        return
      }
    }

    // TODO: Validar que no sea el mismo producto condición y promoción

    const esTipoCliente = this.formHeader.get("buscarPor").value === this.TIPO_TIPO_CLIENTE

    // const { unidad_negocio_codigo } = this.formHeader.value
    const unidad_negocio_codigo = this.formValidatorsService.obtenerValorFormHeader(this.formHeader, 'unidad_negocio_codigo')
    let newPromocion = {
      cabecera: {
        codigo: Number(this.codigoPromocion),
        sucursal_codigo: Number(this.sucursalEmpresa),
        rut_empresa: this.rutEmpresa,
        fecha_inicio: this.formHeader.get("fechaInicio").value,
        fecha_termino: this.formHeader.get("fechaFin").value,
        activo: this.formHeader.get("activo").value,
        unidad_negocio_codigo: this.permiteUnidadNegocio ? unidad_negocio_codigo : null
      },
      tipo_cliente: [],
      esTipoCliente,
      clientesAfectados: [],
      productosAfectados: []
    }
    if (esTipoCliente && this.tiposClientesSeleccionados) {
      newPromocion.tipo_cliente = this.tiposClientesSeleccionados.map(tipo => (
        { codigo: tipo.codigo }))
    }
    else if (this.clientesSeleccionados) {
      newPromocion.clientesAfectados = this.clientesSeleccionados.map(cliente => (
        {
          promocion_codigo: this.codigoPromocion,
          cliente_proveedor_rut: cliente.rut,
          direccion_codigo: cliente.codigo_direccion,
          fecha_registro: cliente.fecha_registro,
          empresa_rut: cliente.empresa_rut
        }
      ))
    }

    // sku
    // descripcion
    // formato
    // formatoGlosa
    // cantidad
    // tipoDescuento
    // tipoDescuentoGlosa
    // monto
    // porcentaje
    // index
    newPromocion.productosAfectados = this.listaPromocionesCondicion.map(producto => ({
      promocion_codigo: this.codigoPromocion,
      producto_codigo: producto.codigo,
      formato_codigo: producto.formato,
      empresa_rut: producto.empresa_rut,
      cantidad: producto.cantidad,
      monto: 0, // siempre cero, campo deprecado
      porcentaje_descuento: producto.tipoDescuento === "2" ? producto.porcentaje : 0,
      valor: producto.tipoDescuento === "1" ? producto.monto : 0,
      es_condicion: true,
    }))

    newPromocion.productosAfectados = newPromocion.productosAfectados.concat(this.listaPromocionesPromocion.map(producto => ({
      promocion_codigo: this.codigoPromocion,
      producto_codigo: producto.codigo,
      formato_codigo: producto.formato,
      empresa_rut: producto.empresa_rut,
      cantidad: producto.cantidad,
      monto: 0, // siempre cero, campo deprecado
      porcentaje_descuento: producto.tipoDescuento === "2" ? producto.porcentaje : 0,
      valor: producto.tipoDescuento === "1" ? producto.monto : 0,
      es_condicion: false,
    })))

    const self = this

    this.log('inputParams', JSON.stringify({
      entidad: newPromocion
    }))

    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation($entidad: promocionDTOInputType) {

            promocion {
              guardarDTO(entidad: $entidad)
              {
                mensajes
                {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  cabecera{
                    codigo
                    sucursal_codigo
                    rut_empresa
                    fecha_inicio
                    fecha_termino
                    activo
                  }
                  clientesAfectados{
                    promocion_codigo
                    cliente_proveedor_rut
                    direccion_codigo
                    empresa_rut
                    fecha_registro
                  }
                  esTipoCliente
                  productosAfectados{
                    promocion_codigo
                    producto_codigo
                    formato_codigo
                    empresa_rut
                    cantidad
                    monto
                    porcentaje_descuento
                    valor
                  }
                }
              }
            }
          }
        `,
        variables: {
          entidad: newPromocion
        },
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.promocion.guardarDTO
        const ok = respuesta !== null
        if (!ok) {
          self.messageRendererService.showErrors(mensajes)
          return
        }
        else {
          self.toastrService.success('Promoción guardada')
          self.hide()
          self.onSuccess.emit()
          return
        }
      }
    );
  }

  load(rut_empresa, sucursal_codigo, codigo, allowEdit: boolean = true) {
    this.mode = allowEdit ? 'EDIT' : 'VIEW'
    this.codigoPromocion = codigo
    const _variables = {
      rut_empresa,
      sucursal_codigo,
      codigo
    }

    this.loaded = false
    this.loading = true
    this.formHeader.get("unidad_negocio_codigo").disable()

    const self = this
    this.gqlclient.query(
      {
        query: gql`
        query
            (
              $rut_empresa: Decimal,
              $sucursal_codigo: Decimal,
              $codigo: Decimal
            )
        {

          promocion{
            obtenerSegunId
            (entidad:{
              rut_empresa: $rut_empresa
              sucursal_codigo: $sucursal_codigo
              codigo: $codigo
            })
            {
              mensajes
              {
                codigo
                contexto
                texto
                tipo
              }
              respuesta{
                codigo
                sucursal_codigo
                rut_empresa
                fecha_inicio
                fecha_termino
                activo
                unidad_negocio_codigo
              }
            }
          }

          promocion_detalle_cliente{
            obtenerSegunFiltro(filtro:{exacto:{
              promocion_codigo: $codigo
              empresa_rut: $rut_empresa
              cliente_proveedor_rut: -1
              direccion_codigo: -1
            }})
            {
              mensajes
              {
                codigo
                contexto
                texto
                tipo
              }
              respuesta{
                registros{
                  promocion_codigo
                  cliente_proveedor_rut
                  direccion_codigo
                  empresa_rut
                  fecha_registro
                  nombreCliente
                }

              }
            }
          }

          promocion_detalle_producto{
            obtenerSegunFiltro
            (
              filtro:{
                exacto:{
                  promocion_codigo: $codigo
                  empresa_rut: $rut_empresa
                  es_condicion: true
                  producto_codigo: -1
                  formato_codigo:""
                }
              }
            ){
              mensajes{
                codigo
                contexto
                texto
                tipo
              }
              respuesta
              {
                registros{
                  promocion_codigo
                  producto_codigo
                  formato_codigo
                  empresa_rut
                  cantidad
                  monto
                  porcentaje_descuento
                  valor
                  es_condicion
                  sku
                  nombreProducto
                  nombreFormato
                }
              }
            }
          }

        }

         `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // Header
        const { respuesta: respHeader } = response.data.promocion.obtenerSegunId
        self.formHeader.get('activo').setValue(respHeader.activo)//: ['', [Validators.required]],
        self.formHeader.get('fechaInicio').setValue(respHeader.fecha_inicio)//: [0, [Validators.required, Validators.min(1)]],
        self.formHeader.get('fechaFin').setValue(respHeader.fecha_termino)//: [0, [Validators.required, Validators.min(1)]],
        self.formHeader.get('unidad_negocio_codigo').setValue(respHeader.unidad_negocio_codigo)//: [0, [Validators.required, Validators.min(1)]],

        // Clientes
        const { respuesta: respClientes } = response.data.promocion_detalle_cliente.obtenerSegunFiltro
        const { registros: regsClientes } = respClientes
        const clientesSeleccionados = regsClientes.map(cliente => ({
          rut: cliente.cliente_proveedor_rut,
          codigo_direccion: cliente.direccion_codigo,
          fecha_registro: cliente.fecha_registro,
          empresa_rut: cliente.empresa_rut,
          nombre: cliente.nombreCliente
        }))
        // self.onClienteSeleccionadoMultiple({ data: clientesSeleccionados, origen: null })
        self.modalSeleccionarCliente.setClientesSeleccionadosFromOutside(clientesSeleccionados)

        // this.clientesSeleccionados = data
        // this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map(p => p.nombre).join(', ')

        // if (esTipoCliente && this.tiposClientesSeleccionados) {
        //   newPromocion.tipo_cliente = this.tiposClientesSeleccionados.map(tipo => (
        //     { codigo: tipo.codigo }))
        // }
        // else if (this.clientesSeleccionados) {
        //   newPromocion.clientesAfectados = this.clientesSeleccionados.map(cliente => (
        //     {
        //       promocion_codigo: this.codigoPromocion,
        //       cliente_proveedor_rut: cliente.rut,
        //       direccion_codigo: cliente.codigo_direccion,
        //       fecha_registro: cliente.fecha_registro,
        //       empresa_rut: cliente.empresa_rut
        //     }
        //   ))




        // Productos condición y promoción
        const { respuesta: respProductos } = response.data.promocion_detalle_producto.obtenerSegunFiltro
        const { registros: regsProductos } = respProductos
        self.listaPromocionesCondicion = regsProductos.filter(p => p.es_condicion).map((producto, index) => self.mapProductResponse2ProductList(producto, index))
        self.listaPromocionesPromocion = regsProductos.filter(p => !p.es_condicion).map((producto, index) => self.mapProductResponse2ProductList(producto, index))

        self.show(self.mode)
      }
    );
  }

  mapProductResponse2ProductList(producto, index) {
    return {
      sku: producto.sku,
      codigo: producto.producto_codigo,
      empresa_rut: producto.empresa_rut,
      descripcion: producto.nombreProducto,
      formato: producto.formato_codigo,
      formatoGlosa: producto.nombreFormato,
      cantidad: producto.cantidad,
      tipoDescuento: producto.porcentaje_descuento > 0 ? "2" : "1",
      tipoDescuentoGlosa: this.optionsTipoDescuento.filter(opt => Number(opt.value) === (producto.porcentaje_descuento > 0 ? 2 : 1))[0].label,
      monto: producto.valor > 0 ? producto.valor : 0,
      porcentaje: producto.porcentaje_descuento > 0 ? producto.porcentaje_descuento : 0,
      index
    }
  }

  /********* OPERATIONS *********/

  verClientesSeleccionados() {
    this.modalShowClientes.show(this.clientesSeleccionados)
  }

}
